// extracted by mini-css-extract-plugin
export default {"pagination-container":"CommonPagination_pagination-container__cWqMK","active":"CommonPagination_active__1MWl3"};